import Checkout from '../../components/Checkout/Checkout';
// import { getStoreShippingDefaultDiscounts } from '@/util/API/discounts';
// import { logObject } from '@/util/logger';

export default function CheckoutPage() {
	// const shippingDiscounts =
	// 	await getStoreShippingDefaultDiscounts();

	// logObject(shippingDiscounts);

	return <Checkout />;
}
